import React from 'react';
type CheckboxFieldProps = {
  name: string;
  label: React.ReactNode;
  required?: boolean;
};
export function CheckboxField({
  name,
  label,
  required
}: CheckboxFieldProps) {
  const id = `field-${name}`;
  return <label htmlFor={id} className="flex cursor-pointer items-start gap-3 py-2" data-id="element-53" data-mp="ypgaxfmlnoro">
      <input id={id} name={name} type="checkbox" required={required} className="mt-1 h-4 w-4 shrink-0 cursor-pointer accent-[#ff3b3f]" data-id="element-54" data-mp="12p8jvtfwnwxk" />
      <span className="text-sm leading-relaxed text-ink-muted" data-id="element-55" data-mp="1veffoknz68f4">
        {label}
        {required && <span className="text-neon-2" data-id="element-56" data-mp="1hewj8p4j0lin"> *</span>}
      </span>
    </label>;
}